import { unfolder, urlValue, useTranslate } from '../../lib'
import { InputNesting } from '../common/Inputs/Input'
import ExcelUploadButton from './ExcelUploadButton'
import { SelectNesting } from '../common/Inputs/Select'
import CheckBox2 from '../CheckBox2'
import ButtonYesNo from '../common/ButtonYesNo'
import BoxInfo from '../common/BoxInfo'
import { AddCategoryModal } from '../AddCategoryModal';
import { AddEvaluationCriteriaModal } from '../AddEvaluationCriteriaModal';
import { useState, useEffect } from 'react'
import axios from 'axios'

export default function WizardStep4({ questions, setQuestions, formData, setFormData, loadingCategories, categoriesApi, 
  customEvaluation, setCustomEvaluation}) {
  const { t } = useTranslate();
  const [isAddCategoryModalOpen, setIsAddCategoryModalOpen] = useState(false);
  const [isAddEvaluationCriteriaModalOpen, setIsAddEvaluationCriteriaModalOpen] = useState(false);
  const [useValueQuestion, setUseValueQuestion] = useState(0)
  const [selectedIndustry, setSelectedIndustry] = useState('Other');


  const industries = [
    { id: 1, name: "BFSI" },
    { id: 2, name: "Gaming" },
    { id: 3, name: "News & Media" },
    { id: 4, name: "Tech App Food & Delivery" },
    { id: 5, name: "Tech-Home Services" },
    { id: 6, name: "Telecom" },
    { id: 7, name: "Travel & Hospitality" },
    { id: 8, name: "Other" },
    // { id: 9, name: "Custom" },
  ]

  useEffect(() => {
    setUseValueQuestion(formData.useValueQuestion)
  }, []);

  const onChangeQuestion = (e, index) => {
    const q = [...questions];
    q[index].question = e.target.value;
    setQuestions(q);
  };

  const onChangeSuggested = (e, index) => {
    const q = [...questions];
    q[index].suggested = e.target.value;
    setQuestions(q);
  };

  const onChangeValue = (e, index) => {
    const q = [...questions];
    q[index].value = e.target.value
    setQuestions(q)
  }

  const onChangeCategory = (e, index) => {
    const q = [...questions];
    q[index].category = e.target.value;
    setQuestions(q);
  };

  const handleAutofailChange = (selectedIndex) => {
    console.log("selectedIndex", selectedIndex)
    setQuestions(prev =>
      prev.map((q, i) => ({
        ...q,
        autofail: i === selectedIndex ? (q?.autofail === 1 ? 0 : 1) : 0
      }))
    );
  };

  const handleIndustryChange = (e) => {
    const value = e.target.value;
    setSelectedIndustry(value);
    setFormData({ ...formData, industry: value})
    
    // Si no es Custom, resetear selected_custom_evaluation_id
    if (value !== 'Custom') {
      setCustomEvaluation({
        ...customEvaluation,
        selected_custom_evaluation_id: 0
      });
    }
  };

  const handleCustomEvaluationSelect = (e) => {
    const selectedId = parseInt(e.target.value);
    setCustomEvaluation({
      ...customEvaluation,
      selected_custom_evaluation_id: selectedId
    });
  };

  const handleOpenAddEvaluationCriteriaModal = () => {
    setIsAddEvaluationCriteriaModalOpen(true);
  };

  const handleCloseAddEvaluationCriteriaModal = () => {
    setIsAddEvaluationCriteriaModalOpen(false);
  };

  const handleEvaluationCriteriaAdded = (evaluationData) => {
    // Agregar nueva evaluación al arreglo
    const newEvaluation = {
      id: Date.now(),
      name: evaluationData.name,
      evaluation_structure: evaluationData.evaluation_structure
    };
    
    const currentEvaluations = customEvaluation?.evaluations || [];
    const updatedEvaluations = [...currentEvaluations, newEvaluation];
    
    setCustomEvaluation({
      ...customEvaluation,
      evaluations: updatedEvaluations,
      selected_custom_evaluation_id: newEvaluation.id
    });
    
    // Cambiar industry a Custom
    setSelectedIndustry('Custom');
    // if (industry_ref?.current) {
    //   industry_ref.current.value = 'Custom';
    // }
    
    // openAlert('#alert-ac', () => {
    //   setAlert({ title: t('menu.genai.customCriteriaSaved'), visible: true })
    // }, 4000, () => {
    //   setAlert({ ...alert, visible: false })
    // });
  };

  const handleOpenAddCategoryModal = () => {
    setIsAddCategoryModalOpen(true);
  };

  const handleCloseAddCategoryModal = () => {
    setIsAddCategoryModalOpen(false);
  };

  const addQuestiong = () => {
    setQuestions((prev) => [...prev, { id: `${100}-${Date.now()}`, question: "", suggested: "", value: "0", category: "", autofail: 0 }]);
  };

  const deleteQuestiong = (id) => {
    setQuestions(prev => prev.filter(q => q.id !== id));
  };

  return (
    <div className="wizard-step">
      <h2 className="mb-4" style={{ color: '#0B5FA3', fontSize: 20 }}>
        {t('menu.genai.evaluationFormulary')}
      </h2>

      <div className='flex flex-row items-center w-full' style={{minWidth: 175, marginBottom: 15}}>
        <BoxInfo
          id="questionValue" titleClass='mr-0-4' styles={{ marginBottom: 10 }}
          title={t('menu.genai.questionValue')}
          place="top" containerClass='mr-0-5 '
          content={t('menu.genai.questionValueTooltip')}
        />
        <ButtonYesNo
          onClick={() => {
            setFormData({ ...formData, useValueQuestion: !formData.useValueQuestion})
            setUseValueQuestion((prev) => !prev)
          }}
          width={140}
          state={useValueQuestion}
          height={30}
        />
        <div className='ml-auto' style={{marginRight: 5}}>
          <ExcelUploadButton
            onQuestionsLoaded={(loadedQuestions) => {
              setQuestions(loadedQuestions);
            }}
          />
        </div>
      </div>

      <div className='flex flex-col mt-3'>
        {questions?.map((item, index) => (
          <div key={item.id} style={{ display: 'flex', flexDirection: 'column', marginBottom: 30 }}>
            <InputNesting
              containerClass="w-full"
              defaultValue={item.question}
              onChange={(e) => onChangeQuestion(e, index)}
              title={`${t('common.question')} ${index + 1}:`}
            />
            <InputNesting
              containerClass="w-full"
              style={{ marginTop: 15 }}
              defaultValue={item?.suggested}
              onChange={(e) => onChangeSuggested(e, index)}
              title={`${t('menu.feedback')} ${index + 1}:`}
            />
            <div key={item.id} style={{ display: 'flex', flexDirection: 'row' }}>
            <InputNesting
              defaultValue={item?.value}
              onChange={(e) => onChangeValue(e, index)}
              title={`${t('common.value')} ${index + 1}:`}
              disabled={!useValueQuestion}
              contentStyle={{ width: '70px', margin: '5px 0 10px 5px', height: '65px' }}
            />
            <div style={{ minWidth: 130, display: 'flex', flexDirection: 'column', margin: 5 }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span >{t('menu.genai.category')}:</span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 5 }}>
                <SelectNesting
                  boxInfo={false}
                  tooltipText={t('menu.genai.category')}
                  title="" containerClass="d-flex"
                  style={{ minWidth: 188 }}
                  defaultValue={item?.category}
                  onChange={e => onChangeCategory(e, index)}
                >
                  {loadingCategories && <option>{t('common.loading')}...</option>}
                  {!loadingCategories && categoriesApi && categoriesApi.length > 0 ? (
                    categoriesApi.map(cat => (
                      <option key={cat.id || cat.name} value={cat.name}>{cat.name}</option>
                    ))
                  ) : (
                    !loadingCategories && <option value="">Without categories</option>
                  )}
                </SelectNesting>
              </div>
            </div>
            <div key={`checkautofail ${item.id}:`} className= 'flex items-center gap-3' style={{ width: '80px', marginTop: '30px', marginLeft: '20px' }}>
              <label className="title-color" style={{ marginBottom: 0, marginRight: 2 }}>{t('menu.genai.autoFail')}:</label>
              <CheckBox2 
              onChange={() => { handleAutofailChange(index) }}
                checked={item?.autofail === 1} id={`ck-autofail-${item.id}`} text="Autofail" />

            </div>
            <button
              type='button'
              className='m-2 buttonH'
              style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', maxWidth: 150, marginTop: 40 }}
              onClick={() => deleteQuestiong(item.id)}>
              <img src={'/icons/trash-1.png'} style={{ marginRight: 10, width: 15 }} />
              {t('menu.genai.deleteQuestion')}
            </button>
            </div>
            
          </div>
        ))}
        <button className='btn-add mt-2' type='button' onClick={addQuestiong}>
          <img src='/icons/add-icon-nt.png' style={{ width: 22 }} alt='' />
          <span className='ml-5'>{t('menu.genai.addQuestion')}</span>
        </button>
      </div>

      <div style={{ display: 'flex', alignItems: 'flex-end', gap: '10px', flexWrap: 'wrap', marginTop: 15 }}>
          <div style={{ minWidth: 250 }}>
            <SelectNesting
              id="industry"
              title={`${t('common.industry')}:`} 
              containerClass=" mr-2" 
              defaultValue={formData.industry}
              onChange={handleIndustryChange}
            >
              {industries.map((item, index) => (<option key={index} value={item.name}>{item.name}</option>))}
            </SelectNesting>
          </div>
          
          {/* Mostrar selector y botón solo cuando industry es Custom */}
          {selectedIndustry === 'Custom' && (
            <>
              <div style={{ minWidth: 250, flexGrow: 1 }}>
                <SelectNesting
                  id="custom_evaluation_select"
                  title={`${t('menu.genai.selectCustomEvaluation')}:`}
                  containerClass="mr-1"
                  value={customEvaluation?.selected_custom_evaluation_id || 0}
                  onChange={handleCustomEvaluationSelect}
                >
                  <option value={0}>{t('menu.genai.selectOption')}</option>
                  {customEvaluation?.evaluations?.map((evaluation) => (
                    <option key={evaluation.id} value={evaluation.id}>
                      {evaluation.name}
                    </option>
                  ))}
                </SelectNesting>
              </div>
              
              <button
                type='button'
                onClick={handleOpenAddEvaluationCriteriaModal}
                className='btn-add'
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  marginBottom: '10px',
                  whiteSpace: 'nowrap'
                }}
                title={t('menu.genai.createNewEvaluation')}
              >
                <img src='/icons/add-icon-nt.png' style={{ width: 18, height: 18 }} alt={t('menu.genai.createNewEvaluation')} />
                <span>{t('menu.genai.createNewEvaluation')}</span>
              </button>
            </>
          )}
        </div>

        {formData.channel === 'chat' && (
          <div style={{ marginTop: '15px', maxWidth: '100%' }}>
            <label style={{ 
              fontSize: '14px', 
              color: '#2E2E2E', 
              fontWeight: '700',
              display: 'block',
              marginBottom: '8px'
            }}>
              {t('menu.genai.grammarEvaluationCriteria') || 'Grammar Evaluation Criteria'}:
            </label>
            <div style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '8px',
              padding: '10px',
              backgroundColor: '#f9f9f9',
              borderRadius: '6px',
              border: '1px solid #ddd'
            }}>
              {(() => {
                // Convertir string a array si es necesario
                let currentCriteria = customEvaluation?.grammar_criteria || 'all';
                if (typeof currentCriteria === 'string') {
                  currentCriteria = currentCriteria.split(',').map(c => c.trim()).filter(c => c);
                }
                
                return (
                  <>
                  <label style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '6px 12px',
                    backgroundColor: currentCriteria.includes('all') ? '#0087FF' : '#fff',
                    color: currentCriteria.includes('all') ? '#fff' : '#333',
                    border: '1px solid #0087FF',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '13px',
                    fontWeight: currentCriteria.includes('all') ? '600' : '400',
                    transition: 'all 0.2s'
                  }}>
                    <input
                      type="checkbox"
                      value="all"
                      checked={currentCriteria.includes('all')}
                      onChange={(e) => {
                        let newCriteria;
                        if (e.target.checked) {
                          newCriteria = ['all'];
                        } else {
                          newCriteria = currentCriteria.filter(c => c !== 'all');
                        }
                        setCustomEvaluation({
                          ...customEvaluation,
                          grammar_criteria: newCriteria
                        });
                      }}
                      style={{ marginRight: '6px' }}
                    />
                    {t('common.all') || 'All'}
                  </label>

                  {['spelling', 'punctuation', 'capitalization', 'verb_conjugation', 'word_usage'].map((criterion) => {
                    return (
                      <label
                        key={criterion}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          padding: '6px 12px',
                          backgroundColor: currentCriteria.includes(criterion) ? '#E3F2FD' : '#fff',
                          color: '#333',
                          border: '1px solid #90CAF9',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          fontSize: '13px',
                          transition: 'all 0.2s'
                        }}
                      >
                        <input
                          type="checkbox"
                          value={criterion}
                          checked={currentCriteria.includes(criterion)}
                          onChange={(e) => {
                            let newCriteria;
                            
                            if (e.target.checked) {
                              // Agregar el criterio (y quitar 'all' si estaba)
                              newCriteria = [...currentCriteria.filter(c => c !== 'all'), criterion];
                            } else {
                              // Quitar el criterio
                              newCriteria = currentCriteria.filter(c => c !== criterion);
                            }
                            
                            setCustomEvaluation({
                              ...customEvaluation,
                              grammar_criteria: newCriteria.length > 0 ? newCriteria : ['all']
                            });
                          }}
                          style={{ marginRight: '6px' }}
                        />
                        {t(`menu.genai.grammar.${criterion}`) || criterion.replace('_', ' ')}
                      </label>
                    );
                  })}
                </>
              );
            })()}
          </div>
          <div style={{ 
            fontSize: '12px', 
            color: '#666', 
            marginTop: '6px',
            fontStyle: 'italic'
          }}>
            {t('menu.genai.grammarCriteriaHelp') || 'Select any criteria (multiple selection allowed)'}
          </div>
        </div>
        )}

        <AddCategoryModal
          isOpen={isAddCategoryModalOpen}
          onClose={handleCloseAddCategoryModal}
          // onCategoryAdded={createCategory}
          existingCategories={categoriesApi}
        />
        <AddEvaluationCriteriaModal
          isOpen={isAddEvaluationCriteriaModalOpen}
          onClose={handleCloseAddEvaluationCriteriaModal}
          onEvaluationCriteriaAdded={handleEvaluationCriteriaAdded}
        />
    </div>
  );
}
